// core
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";

// ui primitives (replaced @mui/material — see Components/UI)
import {
    Button,
    Card,
    CircularProgress,
    Stack,
    Typography,
} from "Components/UI";

// assets
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRightToBracket } from "@fortawesome/free-solid-svg-icons";

// services
import { UseMfaLogin } from "Services/LoginAPI";
import { useAuthenticate } from "Services/Authentication";

// components
import OtpInput from "./OtpInput";

// style
import styles from "./LoginForm.module.css"; // Import the styles
import LoginLogo from "./LoginLogo";

// main component
export default function MfaLoginForm(props) {
    // own state
    const [errorMessage, setErrorMessage] = useState("");
    const [loading, setLoading] = useState(false);
    const [newOtp, setOtp] = useState(""); // State to store the combined OTP

    // private handlers
    function handleOtpChange(newOtp) {
        setOtp(newOtp);
    }

    function CompleteLogin(response, skip_animation = false) {
        useAuthenticate(response.user, response.tenant);
        props?.animateGlobe?.animation();
        const LandingPage = response.tenant.landing_page;

        completeRedirect(LandingPage);
    }

    function completeRedirect(LandingPage) {
        const redirectPath = localStorage.getItem("redirectPath") || "/";
        localStorage.removeItem("redirectPath"); // Clear the saved path
        if (redirectPath === "/") {
            window.location.href = LandingPage
                ? `/unixi-management-portal/app/${LandingPage}`
                : "/unixi-management-portal/app/dashboard";
        } else if (redirectPath.startsWith("/unixi-management-portal")) {
            window.location.href = `${redirectPath}`;
        } else {
            window.location.href = `/unixi-management-portal${redirectPath}`;
        }
    }

    function handleMfaLogin() {
        setLoading(true);
        UseMfaLogin(newOtp)
            .then((response) => {
                if (!response) {
                    setErrorMessage("MFA Login failed");
                    return;
                }

                if (response.status) {
                    if (response.status === true) {
                        toast.success("Login successful");
                        CompleteLogin(response, true);
                    } else {
                        setErrorMessage(response.info);
                    }
                } else {
                    setErrorMessage(response.info);
                }
            })
            .catch((error) => {
                setErrorMessage(error.toString());
                console.log(error);
            })
            .finally(() => {
                setLoading(false);
            });
    }

    // watchers
    useEffect(() => {
        if (errorMessage && errorMessage.length > 2) toast.error(errorMessage);
    }, [errorMessage]);

    // render
    return (
        <Card>
            <Stack gap={3}>
                <div>
                    <Stack align="center" fullWidth>
                        <LoginLogo />
                    </Stack>

                    <Stack align="center" fullWidth>
                        <Typography variant="h6">
                            Please enter your OTP to login
                        </Typography>
                    </Stack>
                </div>

                <form>
                    <Stack gap={2}>
                        <OtpInput onOtpChange={handleOtpChange} />

                        <Button
                            onClick={handleMfaLogin}
                            type="submit"
                            className={styles.submitButton}
                            disabled={loading}
                            endIcon={
                                loading ? (
                                    <CircularProgress size={18} />
                                ) : (
                                    <FontAwesomeIcon icon={faRightToBracket} />
                                )
                            }
                        >
                            Verify
                        </Button>
                    </Stack>
                </form>

                <Stack align="center" fullWidth>
                    <Link to="/login" className={styles.link}>
                        Back to Login
                    </Link>
                </Stack>
            </Stack>
        </Card>
    );
}
